import { render, staticRenderFns } from "./editTechnical.vue?vue&type=template&id=8484a87e&scoped=true&"
import script from "./editTechnical.vue?vue&type=script&lang=js&"
export * from "./editTechnical.vue?vue&type=script&lang=js&"
import style0 from "./editTechnical.vue?vue&type=style&index=0&id=8484a87e&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8484a87e",
  null
  
)

export default component.exports